export interface TranslationFile {
  [index: string]: string;
}
